export var source = "query FlashSaleTimer {\n  flashSaleList {\n    timeLeft\n  }\n}";
export default source;